import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	{
		'@global': {
			body: {
				overflow: ({ sorting }) => (sorting ? 'hidden' : null),
			},
		},
	},
	{ name: 'Page' },
)

export default useStyles
